import { PropsWithChildren } from 'react'
import './iPhone15.css'
import back from './back.png'
import dayjs from 'dayjs'
interface Props {
  link?: string
  hideBackground?: boolean
}
export const IphoneCroped = ({
  link,
  children,
  hideBackground = false,
}: PropsWithChildren<Props>) => {
  return (
    <div style={{ maxHeight: 400, overflow: 'hidden' }}>
      <div className="iphone-container">
        <div className="status-bar">
          <span className="time">{dayjs().format('HH:mm')}</span>
          <div className="network-info">
            <span>4G</span>
          </div>
        </div>
        <div className="notch"></div>
        <div
          className="screen"
          style={
            hideBackground
              ? { backgroundColor: '#efefef' }
              : { backgroundImage: `url(${back})`, backgroundSize: 'cover' }
          }
        >
          {link && (
            <iframe
              src={link}
              title="iPhone Screen"
              className="iframe-screen"
            ></iframe>
          )}
          {children && children}
        </div>
        <div className="home-indicator"></div>
      </div>
    </div>
  )
}
